import type { JSX } from 'react';
import { NavLink } from 'react-router-dom';
import { Chip } from '@heroui/react';

import type { FrameworkManifestEntry } from '~/types';

import { formatFrameworkTitle, TEST_LAYER_LABELS } from '../utils';

interface FrameworkCardProps {
  framework: FrameworkManifestEntry;
}

const TEST_LAYER_COLORS: Record<string, string> = {
  e2e: 'border-l-emerald-500',
  integration: 'border-l-blue-500',
  unit: 'border-l-amber-500',
};

export function FrameworkCard({ framework }: FrameworkCardProps): JSX.Element {
  const accent = TEST_LAYER_COLORS[framework.test_layer] ?? 'border-l-default';

  return (
    <NavLink
      to={`/patterns/framework/${framework.framework_id}`}
      className={`block p-5 rounded-lg border border-default border-l-4 ${accent} bg-surface hover:bg-surface-elevated transition-colors`}
    >
      <h3 className="text-base font-semibold text-foreground mb-1">
        {formatFrameworkTitle(framework.framework_id)}
      </h3>

      <p className="text-xs text-muted line-clamp-2 mb-3">{framework.description}</p>

      <div className="flex items-center gap-2 flex-wrap">
        <Chip size="sm" variant="flat" color="secondary">
          {TEST_LAYER_LABELS[framework.test_layer] ?? framework.test_layer}
        </Chip>
        {framework.tech_stack.map(tech => (
          <Chip key={tech} size="sm" variant="bordered">
            {tech}
          </Chip>
        ))}
      </div>
    </NavLink>
  );
}
